import App from './App'
import 'javascript/dayjs'
import Vue from 'vue'
import { pinia } from 'Store'
import FaqWidgetApp from 'javascript/FaqWidget/FaqWidgetApp'
import { EventBus } from './ChatWidget/EventBus'

export default function () {
  console.info('triplabot - latest')

  if (!global._babelPolyfill) {
    require('@babel/polyfill')
  }

  let chatWidgetReady = false
  EventBus.$on('chat-widget-ready', () => (chatWidgetReady = true))

  const pakku = new App()

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      pakku.init()
      initFAQWidget()
    })
  } else {
    pakku.init()
    initFAQWidget()
  }

  function initFAQWidget() {
    const elements = document.querySelectorAll('[data-tripla-faq-widget-toggle="1"]')
    const url = new URL(window.location.href)
    let openAction = url?.searchParams?.get?.('faq_widget_open')

    if (!openAction && url?.searchParams.has('redirect_url')) {
      try {
        const redirectUrl = new URL(url?.searchParams.get('redirect_url'))

        if (redirectUrl.origin === url.origin) {
          openAction = redirectUrl?.searchParams?.get?.('faq_widget_open')
        }
      } catch (e) {
        // ignore
      }
    }

    if (elements.length > 0 || openAction) {
      const faqWidgetContainer = document.createElement('div')
      faqWidgetContainer.id = 'tripla-faq-widget'
      document.body.appendChild(faqWidgetContainer)

      new Vue({
        el: '#' + faqWidgetContainer.id,
        pinia,
        render: (h) =>
          h(FaqWidgetApp, {
            props: { elements: [...elements], openAction },
            attrs: { chatWidgetReady }
          })
      })
    }
  }
}
